import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
  class: "proofreading"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "question"
};
const _hoisted_6 = {
  class: "answer"
};
const _hoisted_7 = {
  class: "examples"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "examples-answer"
};
const _hoisted_10 = {
  class: "menu"
};
const _hoisted_11 = ["innerHTML"];
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "answer-box"
};
const _hoisted_14 = {
  class: "content-no"
};
const _hoisted_15 = {
  class: "content-sentence"
};
const _hoisted_16 = ["contenteditable", "innerHTML", "onFocus"];
const _hoisted_17 = {
  class: "content-answer"
};
const _hoisted_18 = {
  key: 0,
  class: "menu"
};
const _hoisted_19 = {
  key: 1,
  class: "answer-type"
};
const _hoisted_20 = ["onUpdate:modelValue", "onInput"];
const _hoisted_21 = {
  class: "answer-box-title-out"
};
const _hoisted_22 = {
  class: "answer-box-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_cache[21] || (_cache[21] = _createElementVNode("p", {
    style: {
      "margin-bottom": "5px"
    }
  }, "示例", -1)), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.examples, (examplesItem, examplesIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "examples-item",
      key: 'examples' + examplesIndex
    }, [_createElementVNode("div", {
      class: "examples-sentence",
      innerHTML: examplesItem.sentence
    }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(examplesIndex + 1), 1), _createElementVNode("span", {
      class: "text",
      innerHTML: examplesItem.answer
    }, null, 8, _hoisted_11)]), _createElementVNode("div", {
      class: "examples-explain",
      innerHTML: examplesItem.explain
    }, null, 8, _hoisted_12)]);
  }), 128))]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
    class: "answer-box-title",
    style: _normalizeStyle({
      opacity: $setup.titleSwitch ? 0 : 1
    })
  }, [_cache[12] || (_cache[12] = _createElementVNode("div", null, "原文参考", -1)), _createElementVNode("div", null, [_createVNode(_component_el_button, {
    class: "button",
    type: "success",
    size: "small",
    onClick: _cache[0] || (_cache[0] = $event => $setup.modify(''))
  }, {
    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("重改", -1)]))]),
    _: 1
  }), _createVNode(_component_el_button, {
    disabled: !!($setup.answer[$setup.modifItem.id] && $setup.answer[$setup.modifItem.id].length),
    class: "button",
    type: "warning",
    size: "small",
    onClick: _cache[1] || (_cache[1] = $event => $setup.modify('change'))
  }, {
    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("修改", -1)]))]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    disabled: !!($setup.answer[$setup.modifItem.id] && $setup.answer[$setup.modifItem.id].length),
    class: "button",
    type: "warning",
    size: "small",
    onClick: _cache[2] || (_cache[2] = $event => $setup.modify('del'))
  }, {
    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("删除", -1)]))]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    disabled: !!($setup.answer[$setup.modifItem.id] && $setup.answer[$setup.modifItem.id].length),
    class: "button",
    type: "warning",
    size: "small",
    onClick: _cache[3] || (_cache[3] = $event => $setup.modify('insert'))
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("插入", -1)]))]),
    _: 1
  }, 8, ["disabled"])]), _cache[13] || (_cache[13] = _createElementVNode("div", null, "错误修改", -1))], 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList, (questionGroupItem, questionGroupIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "answer-box-content",
      key: 'questionGroupIndex' + questionGroupIndex
    }, [_createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("div", {
      class: "menu"
    }, _toDisplayString($setup.menu[questionGroupIndex]), 513), [[_vShow, $setup.menu[questionGroupIndex]]])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("p", {
      class: _normalizeClass($setup.menu[questionGroupIndex] ? 'can-select' : ''),
      contenteditable: $setup.menu[questionGroupIndex] ? true : false,
      innerHTML: $setup.answer[questionGroupItem.questionList[0].questionId] || $setup.cleanQuestionList[questionGroupIndex],
      onFocus: e => {
        $setup.menu[questionGroupIndex] ? $setup.setDom(e, $setup.cleanQuestionList[questionGroupIndex], questionGroupItem.questionList[0].questionId) : '';
      }
    }, null, 42, _hoisted_16)]), _createElementVNode("div", _hoisted_17, [$setup.menu[questionGroupIndex] ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.menu[questionGroupIndex]), 1)) : _createCommentVNode("", true), $setup.menu[questionGroupIndex] ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_withDirectives(_createElementVNode("del", null, _toDisplayString($setup.editRecord[questionGroupIndex].text), 513), [[_vShow, $setup.editRecord[questionGroupIndex].type == 'del']]), _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "input here",
      "onUpdate:modelValue": $event => $setup.editRecord[questionGroupIndex].text = $event,
      onInput: $event => $setup.setEditAnswer($setup.editRecord[questionGroupIndex])
    }, null, 40, _hoisted_20), [[_vShow, $setup.editRecord[questionGroupIndex].type == 'insert' || $setup.editRecord[questionGroupIndex].type == 'change'], [_vModelText, $setup.editRecord[questionGroupIndex].text]]), _cache[14] || (_cache[14] = _createTextVNode("   ", -1))])) : _createCommentVNode("", true)])]);
  }), 128))]), _createElementVNode("div", _hoisted_21, [_withDirectives(_createElementVNode("div", _hoisted_22, [_cache[19] || (_cache[19] = _createElementVNode("div", null, "原文参考", -1)), _createElementVNode("div", null, [_createVNode(_component_el_button, {
    class: "button",
    type: "success",
    size: "small",
    onClick: _cache[4] || (_cache[4] = $event => $setup.modify(''))
  }, {
    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("重改", -1)]))]),
    _: 1
  }), _createVNode(_component_el_button, {
    disabled: !!($setup.answer[$setup.modifItem.id] && $setup.answer[$setup.modifItem.id].length),
    class: "button",
    type: "warning",
    size: "small",
    onClick: _cache[5] || (_cache[5] = $event => $setup.modify('change'))
  }, {
    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("修改", -1)]))]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    disabled: !!($setup.answer[$setup.modifItem.id] && $setup.answer[$setup.modifItem.id].length),
    class: "button",
    type: "warning",
    size: "small",
    onClick: _cache[6] || (_cache[6] = $event => $setup.modify('del'))
  }, {
    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("删除", -1)]))]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_el_button, {
    disabled: !!($setup.answer[$setup.modifItem.id] && $setup.answer[$setup.modifItem.id].length),
    class: "button",
    type: "warning",
    size: "small",
    onClick: _cache[7] || (_cache[7] = $event => $setup.modify('insert'))
  }, {
    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("插入", -1)]))]),
    _: 1
  }, 8, ["disabled"])]), _cache[20] || (_cache[20] = _createElementVNode("div", null, "错误修改", -1))], 512), [[_vShow, $setup.titleSwitch]])])])])]);
}